import { CustomUseQueryOptions } from '../types';
import { getOptions } from '@/libs/sdk/contracts';
import { useQuery } from '@tanstack/react-query';
import type { Address, PublicClient } from 'viem';

export const useOptions = (client: PublicClient, address?: Address, options?: CustomUseQueryOptions<readonly Address[]>) => {
  const { queryKey, enabled = true, ...rest } = options || {};
  return useQuery({
    ...rest,
    enabled: enabled && !!address,
    queryKey: [queryKey, 'UseOptions', client, address],
    queryFn: async () => await getOptions(address!, client),
  });
};
